// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'fuel_cards/:pathMatch(.*)?',
        name: consts.routerNames.fuel_cards.main,
        meta: {
            list: 'FuelCardsList',
            mainRouteName: consts.routerNames.fuel_cards.main,
            showMap: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/FuelCardsPage.vue')
    },
];

export default routes;